import React from 'react';
import TextField from '@mui/material/TextField';
import FormDialog from './FormDialog';

/**
 * CreateAssignmentDialog - Dialog for creating new assignments
 * @param {boolean} open - Whether the dialog is open
 * @param {string} description - Current description value
 * @param {Function} onDescriptionChange - Callback when description changes
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onCreate - Callback when create is confirmed
 * @param {boolean} loading - Whether creation is in progress
 */
export default function CreateAssignmentDialog({
  open,
  description,
  onDescriptionChange,
  onClose,
  onCreate,
  loading = false
}) {
  return (
    <FormDialog
      open={open}
      title="Create Assignment"
      onClose={onClose}
      onConfirm={onCreate}
      confirmLabel="Create"
      loading={loading}
    >
      <TextField
        autoFocus
        margin="dense"
        label="Description"
        fullWidth
        variant="outlined"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        disabled={loading}
      />
    </FormDialog>
  );
}
